import React, { useState } from 'react';
import useTranslate from '../../../../customHooks/useTranslate';
import {
    useProperty,
    usePropertyFetching,
    usePropertyImagesDetail,
    usePropertyRoomDetail,
} from '../../../contextsProperty/ContextProperties';
import Card from '../../../../muiComponents/Card';
import Title from '../Title';
import GridChild from '../../../../muiComponents/GridChild';
import Grid from '../../../../muiComponents/Grid';
import { imageSmallColumnGrid } from '../../../../utils/property/propertyUtils';
import ImageCard from './ImageCard';
import Button from '../../../../muiComponents/Button';
import AddImagesPanel from './AddImagesPanel';
import DeletePopUp from '../DeletePopUp';
import LoadingTab from '../LoadingTab';
import {
    gridSpacing30,
    gridSpacing40,
} from '../../../../utils/commonVariables/grid';

const RoomImagesList = () => {
    const translate = useTranslate();
    const { images, toggleRoomImageIs360, toggleRoomImageFeature } =
        usePropertyRoomDetail();
    const { isOpenPanel, setAddRoomImageDetail } = usePropertyImagesDetail();
    const { handleDeleteImage } = useProperty();
    const [idDeletePopUpVisible, setIdDeletePopUpVisible] = useState('');

    const { isFetching } = usePropertyFetching();

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <>
            <main className='property-page__content flex-column gap-20'>
                <section className='flex-column gap-10'>
                    <div className='flex flex-between flex-align-center'>
                        <div className='flex-grow'>
                            <Title
                                text={'room_images'}
                                className='text-align-center'
                            />
                        </div>
                        <Button
                            variant='contained'
                            onClick={() => {
                                setAddRoomImageDetail();
                            }}
                        >
                            {translate('add_images')}
                        </Button>
                    </div>
                    <Card className='flex flex-center padding20'>
                        {images.length ? (
                            <Grid
                                columnSpacing={gridSpacing30}
                                rowSpacing={gridSpacing40}
                                style={{ width: 'unset' }}
                            >
                                {images.map((img, ind) => (
                                    <GridChild
                                        gridProps={imageSmallColumnGrid}
                                        key={img?.id || ind}
                                    >
                                        <ImageCard
                                            image={img}
                                            onDelete={() =>
                                                setIdDeletePopUpVisible(img.id)
                                            }
                                            onToggleFeatured={() => {
                                                toggleRoomImageFeature(img.id);
                                            }}
                                            onToggle360={() => {
                                                toggleRoomImageIs360(img.id);
                                            }}
                                        />
                                    </GridChild>
                                ))}
                            </Grid>
                        ) : (
                            <Button
                                variant='text'
                                startIcon={'Add'}
                                onClick={() => {
                                    setAddRoomImageDetail();
                                }}
                            >
                                {translate('add_images')}
                            </Button>
                        )}
                    </Card>
                </section>
            </main>
            <AddImagesPanel open={isOpenPanel} isDropdownVisible={false} />
            <DeletePopUp
                open={!!idDeletePopUpVisible}
                onSave={async () => {
                    await handleDeleteImage(idDeletePopUpVisible);
                    setIdDeletePopUpVisible('');
                }}
                onCancel={() => {
                    setIdDeletePopUpVisible('');
                }}
            />
        </>
    );
};

export default RoomImagesList;
